module.exports = __webpack_public_path__ + "static/media/london-11.dfcc9bb8.svg";